import { BLOCK_FIXTURES } from '@web-studio/core-fixtures';
import { THEME_REGISTRY } from '@web-studio/shared-schemas';
import {
  implementedBlockCatalog,
  IMPLEMENTED_COMPONENT_TYPES,
  registryOnlyBlockKeys,
} from './blockCatalog';
import { enumerateBlockThemeMatrix } from './enumerate';
import type { BlockCoverageRow, CoverageReport } from './types';

export function computeCoverageReport(): CoverageReport {
  const allCells = enumerateBlockThemeMatrix({ includeRegistryOnly: false });
  const renderedCells = allCells.filter((c) => c.implementationStatus === 'rendered');

  const themeCount = Object.keys(THEME_REGISTRY).length;
  const colorsetCount = Object.values(THEME_REGISTRY).reduce(
    (sum, t) => sum + t.color_sets.length,
    0,
  );

  const rows: BlockCoverageRow[] = implementedBlockCatalog().map((row) => {
    const blockCells = allCells.filter((c) => c.componentType === row.componentType);
    const rendered = blockCells.filter((c) => c.implementationStatus === 'rendered');
    const fixtureCount = BLOCK_FIXTURES.filter(
      (f) => f.componentType === row.componentType,
    ).length;

    return {
      componentType: row.componentType,
      registryKey: row.registryKey,
      implemented: IMPLEMENTED_COMPONENT_TYPES.includes(row.componentType),
      fixtureCount,
      themeCellsRendered: rendered.length,
      themeCellsTotal: blockCells.length,
      verticals: row.verticals,
    };
  });

  return {
    themes: themeCount,
    colorsets: colorsetCount,
    implementedBlocks: IMPLEMENTED_COMPONENT_TYPES.length,
    registryOnlyBlocks: registryOnlyBlockKeys().length,
    renderedCells: renderedCells.length,
    totalBlockCells: allCells.length,
    rows,
  };
}
